import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../Icon';
import SwitchBase from '../SwitchBase';
import { IconColors } from '../../constants';
import { actions as callActions, selectors as callSelectors, } from '../../../call';
import PinIcon from '../../../call/assets/icons/pin.svg';
const SwitchPin = ({ size, variant, participantId, disabled, }) => {
    const dispatch = useDispatch();
    const isActive = useSelector((state) => callSelectors.isParticipantPinned(state, participantId));
    const switchHandle = useCallback(() => {
        dispatch(callActions.pinStream(participantId));
    }, [participantId]);
    const icon = (<Icon size={size} color={isActive ? IconColors.Secondary : IconColors.Primary} variant={variant}>
      <PinIcon />
    </Icon>);
    return (<SwitchBase activeElement={icon} inactiveElement={icon} isActive={isActive} disabled={disabled} switchHandle={switchHandle}/>);
};
export default SwitchPin;
